module.exports = __webpack_public_path__ + "static/media/visible_spectrum2.e8e23160.png";